export default function ({ $axios, $config }) {
  // Request interceptor - hanya set header
  // Backend yang handle semua encryption/decryption secara otomatis
  $axios.onRequest((config) => {
    if (config.url.includes('/image/api/')) {
      config.url += `?bearer=${$config.barierSecret}`
    }
    config.headers.common.IsWeb = true
    return config
  })

  // Response tidak perlu di-decrypt karena backend sudah mengirim encrypted ID
  // Frontend hanya perlu pass encrypted ID dari response ke URL
}
